export default __webpack_public_path__ + "static/media/clock.b5d0b7cd.svg";